import { render, staticRenderFns } from "./retard.vue?vue&type=template&id=363df3ae&"
import script from "./retard.vue?vue&type=script&lang=js&"
export * from "./retard.vue?vue&type=script&lang=js&"
import style0 from "./retard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports